/**
 * Takes in the error status and determines if it is one of the standard error numbers expected
 * @param errorStatus - Usually found by error.response.status
 * @returns {boolean}
 */
var isStandardErrorStatus = function (errorStatus) {
    var standardErrors = [400, 500, 422];
    return standardErrors.includes(errorStatus);
};
export default isStandardErrorStatus;
//# sourceMappingURL=isStandardErrorStatus.js.map